// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"v2-z","colorTextValue":"w2-z","swatches":"x2-z","collapseLink":"y2-z","isCollapsed":"z2-z","dropdown":"A2-z","disabled":"B2-z"};